/**
 * @generated SignedSource<<df49de6dc899df7f178c94999d6055b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogCard_userProfile$data = {
  readonly analyticsId: number;
  readonly id: string;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentType": "BlogCard_userProfile";
};
export type BlogCard_userProfile$key = {
  readonly " $data"?: BlogCard_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogCard_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogCard_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "analyticsId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "b67c56f2b0a9db1e280e568800d8471f";

export default node;
